import MobileDetect from 'mobile-detect/mobile-detect.min'

export default {
  init() {
    // JavaScript to be fired on all pages
    let url = window.location.href;
    if (url.includes("/project/")) {
      $('.menuContent').find('.projects').addClass('active');
    } else if (url.includes("/u/")) {
      $('.menuContent').find('.ili-u ').addClass('active');
    } else if (url.includes("/barter-system/")) {
      $('.menuContent').find('.barter-system ').addClass('active');
    } else if (url.includes("/events/")) {
      $('.menuContent').find('.events ').addClass('active');
    }

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    $('.menu-navigation').click(function(e){
      e.preventDefault();
      $('.main-menu').addClass('active');
      $('body, html').css('overflow', 'hidden');
    });

    $('.main-menu').find('.close-btn').click(function(e){
      e.preventDefault();
      $('.main-menu').removeClass('active');
      $('body, html').css('overflow', 'auto');
    });

    $('.search-navigation').click(function(e){
      e.preventDefault();
      $('.search-menu').addClass('active');
      $('body, html').css('overflow', 'hidden');
    });

    $('.search-menu').find('.close-btn').click(function(e){
      e.preventDefault();
      $('.search-menu').removeClass('active');
      $('body, html').css('overflow', 'auto');
    });

    let md = new MobileDetect(window.navigator.userAgent);

    if (md.mobile() === null || md.mobile() === "") {
      $(window).scroll(function() {
        let newLoc = $(document).scrollTop();
        let rotationStr = "rotate(" + newLoc + "deg)";
        $("#siteLogo").css({
          "-webkit-transform": rotationStr,
          "-moz-transform": rotationStr,
          "transform": rotationStr
        });
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js